import { PageHeader, Popconfirm, Space, message, Tooltip, Tag } from "antd";
import React, { Component } from "react";
import axios from 'axios'
import moment from 'moment'
import { TableItem, ButtonItem, SegmentedItem, dineroDisabledMask, fmtFechaDia } from "../../../Components/Items";
import HeaderActions from "../../../Components/HeaderActions";
import { connect } from "react-redux";
import { StopOutlined, EditOutlined, CheckCircleOutlined, UserDeleteOutlined, UserAddOutlined, TableOutlined, SafetyCertificateOutlined, WarningOutlined, DownloadOutlined, FieldTimeOutlined, MergeCellsOutlined, ExportOutlined } from '@ant-design/icons'
import ModalValidacionTimbrado from "./ModalValidacionTimbrado/ModalValidacionTimbrado";
import ModalReingreso from "./Reingreso/ModalReingreso";
import ModalUnificarDuplicados from "./Unificar/ModalUnificarDuplicados";
import ModalUnificarEmpleado from "./Unificar/ModalUnificarEmpleado";
import ModalSbcDesactualizado from "./ModalSbcDesactualizado/ModalSbcDesactualizado";
import ModalExportarEmpleados from "./ExportarEmpleados/ModalExportarEmpleados";
import ModalTraspasoEmpleados from "./Traspaso/ModalTraspasoEmpleados";
import ModalCopiarBiometria from "./CopiarBiometria/ModalCopiarBiometria"; // TEMPORAL
import { CAUSA_FINIQUITO_LABEL } from "./causaFiniquito";
import {
  MOTIVO_SBC_TEXTO, SBC_COLOR, SBC_TAG_COLOR, nombreEstadoSbc, claseFilaSbc, resumirRevisionSbc,
} from "./sbc";
import {
  COLOR_SIN_TIMBRAR, CLASE_FILA_SIN_TIMBRAR, MAX_RECIBOS_TOOLTIP, numRecibosSinTimbrar, tieneRecibosSinTimbrar,
  contarEmpleadosSinTimbrar, encabezadoRecibo, motivoRecibo,
} from "./recibosSinTimbrar";

// El aviso de SBC desfasado se abre solo una vez al día por usuario: un modal en cada entrada a
// Empleados se vuelve un clic reflejo y deja de leerse. El banner sí queda siempre visible.
const LLAVE_AVISO_SBC = "avisoSbcVisto";

// Color de los renglones con asignación de reloj checador (clase .empleado-con-reloj de App.css).
const COLOR_RELOJ = "#13A8A8";

// `Empleado.altaPorPasos.paso` = primer paso pendiente de una ficha incompleta.
const PASO_PENDIENTE_ALTA = {
  0: "validar datos generales en el SAT",
  1: "créditos INFONAVIT / FONACOT",
  2: "demás datos",
  3: "dar de alta (revisión general)",
};

class Empleados extends Component {
  state = {
    todasEmpleados: [],
    loading: false,
    valor: 1,
    validacion: { visible: false, loading: false, resultados: [], masivo: false },
    sbcVisible: false,
    sbcCorrigiendo: false,
    exportarVisible: false,
    reingreso: { visible: false, empleadoId: null },
    unificarDuplicadosVisible: false,
    unificar: { visible: false, duplicadoId: null, conservarId: null },
    traspasoVisible: false,
    copiarBiometriaVisible: false,
  }
  componentDidMount() {
    this.consultarEmpleados(this.state.valor, true);
  }

  consultarEmpleados(valor, abrirAvisoSbc = false) {
    this.setState({ loading: true })
    axios
      .post(
        "empleados/selectTodosEmpleados",
        { empresaId: this.props.empresaId, valor: valor, },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false })
        if (res.data.status === 404) {
          this.setState({ todasEmpleados: [] });
        } else {
          this.setState({
            todasEmpleados: res.data
          });
          if (abrirAvisoSbc) this.abrirAvisoSbcUnaVezAlDia(res.data);
        }
      });
  }

  /**
   * Abre el modal de SBC sólo si hay algo que reportar y no se ha mostrado hoy.
   *
   * `localStorage` puede tronar (ventana privada, datos del sitio bloqueados), así que todo va en
   * try/catch: si no se puede leer o escribir la marca, se prefiere no abrir el modal antes que
   * abrirlo en cada recarga.
   */
  abrirAvisoSbcUnaVezAlDia(empleados) {
    // Sin el módulo de nómina el SBC no se usa para nada: ni columna, ni banner, ni aviso.
    if (!this.props.nomina) return;
    const resumen = resumirRevisionSbc(empleados);
    if (!resumen.desfasados) return;
    const hoy = moment().format("YYYY-MM-DD");
    const llave = `${LLAVE_AVISO_SBC}:${this.props.empresaId}`;
    try {
      if (window.localStorage.getItem(llave) === hoy) return;
      window.localStorage.setItem(llave, hoy);
    } catch (e) {
      return;
    }
    this.setState({ sbcVisible: true });
  }

  corregirSbc(empleadoIds) {
    if (!empleadoIds?.length) return;
    this.setState({ sbcCorrigiendo: true });
    axios
      .post(
        "empleados/corregirSbcParteFija",
        { empresaId: this.props.empresaId, empleadoIds },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ sbcCorrigiendo: false });
        if (res.data.success !== 2) {
          message.error(res.data.message || "No se pudo corregir el SBC");
          return;
        }
        const corregidos = res.data.corregidos?.length || 0;
        const omitidos = res.data.omitidos?.length || 0;
        if (corregidos) {
          message.success(corregidos === 1 ? "SBC corregido" : `${corregidos} SBC corregidos`);
        }
        // Los omitidos son los que dejaron de estar desfasados entre que se cargó la pantalla y el
        // clic, o los que no se pudieron evaluar. Vale la pena decirlo: el usuario marcó N y no
        // se tocaron N.
        if (omitidos) {
          message.warning(
            omitidos === 1
              ? "1 empleado se omitió porque ya no requería corrección"
              : `${omitidos} empleados se omitieron porque ya no requerían corrección`,
            5
          );
        }
        this.setState({ sbcVisible: false });
        this.consultarEmpleados(this.state.valor);
      })
      .catch(() => {
        this.setState({ sbcCorrigiendo: false });
        message.error("Error al corregir el SBC");
      });
  }
  agregarEmpleado() {
    this.props.history.push('/panel/agregarEmpleado')
  }
  // Alta por pasos (complemento altaEmpleadoPorPasos). Sin id empieza una ficha nueva; con id
  // retoma una ficha incompleta (estado 3).
  altaEmpleadoPorPasos(id) {
    this.props.history.push('/panel/altaEmpleadoPorPasos', id ? { id } : {})
  }
  editarEmpleado(id, estado) {
    // Una ficha incompleta se edita dentro de su alta por pasos: es el único lugar donde se
    // puede terminar de dar de alta.
    if (estado === 3) return this.altaEmpleadoPorPasos(id)
    this.props.history.push('/panel/editarEmpleado', { id })
  }
  deshabilitarEmpleado(value) {
    axios
      .post(
        "empleados/deshabilitarEmpleado",
        { empleadoId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Empleado deshabilitado");
        } else {
          message.error("Sucedio un eror y no se pudo deshabilitar");
        }
        this.consultarEmpleados(this.state.valor);
      });
  }
  habilitarEmpleado(value) {
    axios
      .post(
        "empleados/habilitarEmpleado",
        { empleadoId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Emplados habilitado");
        } else {
          // El backend explica por qué (baja laboral, finiquito aplicado) y a dónde ir.
          message.error(res.data.message || "Sucedio un eror y no se pudo habilitar", 6);
        }
        this.consultarEmpleados(this.state.valor);
      });
  }
  importarEmpleados() {
    this.props.history.push('/panel/importarEmpleados')
  }

  // ── Validación de datos para timbrar ──────────────────────────────────────
  // Revisa los campos que el CFDI de nómina necesita y, si están completos,
  // consulta el padrón del SAT. El equivalente del "Validar en SAT" de Clientes.
  validarEmpleado(empleadoId) {
    this.setState({ validacion: { visible: true, loading: true, resultados: [], masivo: false } })
    axios
      .post(
        "empleados/validarEmpleadoParaTimbrado",
        { empresaId: this.props.empresaId, empleadoId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          const { success, ...resultado } = res.data
          this.setState({ validacion: { visible: true, loading: false, resultados: [resultado], masivo: false } })
        } else {
          this.setState({ validacion: { visible: false, loading: false, resultados: [], masivo: false } })
          message.error(res.data.message || "No se pudo validar el empleado")
        }
      })
      .catch(() => {
        this.setState({ validacion: { visible: false, loading: false, resultados: [], masivo: false } })
        message.error("Error al validar los datos del empleado")
      })
  }

  // Sin `validarSat` sólo se revisan los datos capturados: es instantáneo. La
  // consulta al padrón es una segunda pasada explícita porque son cientos de
  // llamadas a una API externa, una por empleado.
  validarTodos(validarSat = false) {
    this.setState((prev) => ({
      validacion: { ...prev.validacion, visible: true, loading: true, masivo: true },
    }))
    axios
      .post(
        "empleados/validarEmpleadosParaTimbrado",
        { empresaId: this.props.empresaId, validarSat },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            validacion: { visible: true, loading: false, resultados: res.data.resultados, masivo: true },
          })
          if (validarSat) message.success("Revisión contra el SAT terminada")
        } else {
          this.setState({ validacion: { visible: false, loading: false, resultados: [], masivo: false } })
          message.error(res.data.message || "No se pudieron validar los empleados")
        }
      })
      .catch(() => {
        this.setState({ validacion: { visible: false, loading: false, resultados: [], masivo: false } })
        message.error("Error al validar los empleados")
      })
  }

  cerrarValidacion() {
    this.setState({ validacion: { visible: false, loading: false, resultados: [], masivo: false } })
  }

  // El CFDI de nómina de prueba con el que se validó al empleado, para revisarlo
  // a mano contra lo que el SAT tiene registrado.
  descargarXmlEmpleado(item) {
    axios
      .post(
        "empleados/xmlPruebaEmpleado",
        { empresaId: this.props.empresaId, empleadoId: item.empleadoId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          const blob = new Blob([res.data.xml], { type: "application/xml" })
          const url = URL.createObjectURL(blob)
          const a = document.createElement("a")
          a.href = url
          a.download = res.data.nombreArchivo || "prueba.xml"
          a.click()
          URL.revokeObjectURL(url)
        } else {
          message.error(res.data.message || "No se pudo generar el XML de prueba")
        }
      })
      .catch(() => message.error("Error al descargar el XML de prueba"))
  }
  handleMenuClick(e) {
    if (e.key === '1') {
      this.agregarEmpleado()
    }
    if (e.key === '2') {
      this.importarEmpleados()
    }
  }
  render() {
    const isMobile = window.innerWidth <= 1000;
    const resumenSbc = this.props.nomina
      ? resumirRevisionSbc(this.state.todasEmpleados)
      : { desfasados: 0, menor: 0, mayor: 0 };
    const empleadosSinTimbrar = this.props.nomina
      ? contarEmpleadosSinTimbrar(this.state.todasEmpleados)
      : 0;
    const columns = [
      {
        // El código es el número de empleado real (el que va al CFDI como NumEmpleado y con el
        // que el usuario identifica a la gente); "Numero" es sólo el consecutivo interno EMPn.
        title: "Código",
        dataIndex: "codigo",
        key: "codigo",
        // Los empleados sin código se van al final en lugar de ordenarse como si fueran 0.
        sorter: (a, b) =>
          (a.codigo ?? Number.MAX_SAFE_INTEGER) - (b.codigo ?? Number.MAX_SAFE_INTEGER),
        render: (value) => (value == null ? "" : String(value).padStart(4, "0")),
        // codigoTexto lo arma el backend para que se pueda buscar tanto "12" como "0012".
        buscar: ["codigo", "codigoTexto"],
      },
      {
        title: "Numero",
        dataIndex: "serieNumero",
        key: "serieNumero",
        sorter: (a, b) => {
          if (a.numero < b.numero) {
            return -1;
          }
          if (a.numero > b.numero) {
            return 1;
          }
          return 0;
        },
        buscar: "numero",
      },
      {
        title: "Nombre",
        dataIndex: "nombre",
        key: "nombre",
        sorter: (a, b) => {
          if (a.nombre < b.nombre) {
            return -1;
          }
          if (a.nombre > b.nombre) {
            return 1;
          }
          return 0;
        },
        buscar: "nombre",
        // El color del renglón ya dice "tiene reloj", pero la revisión de SBC le gana al color;
        // el ícono queda siempre y dice en qué reloj y con qué PIN.
        render: (value, record) => (
          record.relojes?.length ? (
            <span>
              <Tooltip title={record.relojes.map((r) => `${r.reloj} · PIN ${r.pin}`).join(" / ")}>
                <FieldTimeOutlined style={{ color: COLOR_RELOJ, marginRight: 6 }} />
              </Tooltip>
              {value}
            </span>
          ) : value
        ),
      },
      {
        title: "RFC",
        dataIndex: "rfc",
        key: "rfc",
        sorter: (a, b) => {
          if (a.rfc < b.rfc) {
            return -1;
          }
          if (a.rfc > b.rfc) {
            return 1;
          }
          return 0;
        },
        buscar: "rfc",
      },
      {
        title: "Fecha Alta",
        dataIndex: "fechaAlta",
        key: "fechaAlta",
        sorter: (a, b) => {
          if (!a.fechaAlta) return -1;
          if (!b.fechaAlta) return 1;
          return new Date(a.fechaAlta) - new Date(b.fechaAlta);
        },
        render: (value) => fmtFechaDia(value, ""),
      },
      {
        // Sin esta columna no hay forma de ver desde el listado quién tiene una baja capturada
        // o un finiquito ya aplicado — sólo se sabía entrando al empleado.
        title: "Baja",
        dataIndex: "fechaBaja",
        key: "fechaBaja",
        align: "center",
        sorter: (a, b) => new Date(a.fechaBaja || 0) - new Date(b.fechaBaja || 0),
        render: (value, record) => {
          // Ficha incompleta del alta por pasos: todavía no es empleado activo.
          if (record.estado === 3) {
            const falta = PASO_PENDIENTE_ALTA[record.altaPorPasos?.paso] || PASO_PENDIENTE_ALTA[0];
            return (
              <Tooltip title="No entra a ninguna nómina hasta terminar su alta por pasos.">
                <div style={{ lineHeight: 1.2 }}>
                  <Tag color="orange" style={{ margin: 0, fontSize: 10 }}>Ficha incompleta</Tag>
                  <div style={{ fontSize: 10, color: "#888", marginTop: 2 }}>Falta: {falta}</div>
                </div>
              </Tooltip>
            );
          }
          // Duplicado unificado: lo del reloj ya está en el otro registro.
          if (record.unificadoCon) {
            return (
              <Tooltip title={`Era el mismo trabajador que ${record.unificadoCon}: su reloj, checadas y biometría pasaron a ese empleado.`}>
                <Tag color="purple" style={{ margin: 0, fontSize: 10, whiteSpace: "normal" }}>
                  Unificado con {record.unificadoCon}
                </Tag>
              </Tooltip>
            );
          }
          // Sin baja vigente pero con reingreso: queda a la vista que ya hubo una baja (y su
          // finiquito). El detalle completo está en el historial de relación laboral.
          const reingreso = record.accion?.ultimoReingreso;
          if (!value && reingreso) {
            return (
              <div style={{ lineHeight: 1.2 }}>
                <Tag color="green" style={{ margin: 0, fontSize: 10 }}>
                  Reingreso {fmtFechaDia(reingreso.fechaReingreso)}
                </Tag>
                <div style={{ fontSize: 10, color: "#888", marginTop: 2 }}>
                  {reingreso.conFiniquito
                    ? `Finiquito anterior ${fmtFechaDia(reingreso.fechaBajaAnterior)}`
                    : `Baja anterior ${fmtFechaDia(reingreso.fechaBajaAnterior)} sin finiquito`}
                </div>
              </div>
            );
          }
          if (!value) return "";
          return (
            <div style={{ lineHeight: 1.2 }}>
              <div style={{ fontSize: 12 }}>{moment.utc(value).format("DD/MM/YYYY")}</div>
              <div style={{ fontSize: 10, color: "#888" }}>
                {CAUSA_FINIQUITO_LABEL[record.causaFiniquito] || record.causaFiniquito || ""}
              </div>
              <div style={{ fontSize: 10, color: record.finiquitoId ? "#3B6D11" : "#C9A227" }}>
                {record.finiquitoId ? "Finiquito aplicado" : "Finiquito pendiente"}
              </div>
            </div>
          );
        },
      },
      // Estado del Salario Base de Cotización, calculado al vuelo por el backend en la misma
      // respuesta del listado (`sbcRevision`). Va condicionada al módulo de nómina: sin nómina el
      // SBC no se usa para nada y la columna sería ruido.
      ...(this.props.nomina ? [{
        title: "SBC",
        key: "sbc",
        align: "center",
        width: 110,
        filters: [
          { text: "Menor al calculado", value: "menor" },
          { text: "Mayor al calculado", value: "mayor" },
          { text: "Correcto", value: "ok" },
          { text: "No evaluable", value: "noEvaluable" },
        ],
        onFilter: (value, record) => record.sbcRevision?.estado === value,
        // Los desfasados primero, y dentro de ellos el más lejano del valor correcto.
        sorter: (a, b) => {
          const peso = (r) => (r?.estado === "menor" ? 0 : r?.estado === "mayor" ? 1 : r?.estado === "noEvaluable" ? 2 : 3);
          const d = peso(a.sbcRevision) - peso(b.sbcRevision);
          if (d !== 0) return d;
          return Math.abs(b.sbcRevision?.diferencia || 0) - Math.abs(a.sbcRevision?.diferencia || 0);
        },
        render: (_, record) => {
          const revision = record.sbcRevision;
          // Sin revisión = deshabilitado, con baja o finiquitado: no tiene SBC que actualizar.
          if (!revision) return <span style={{ color: "#bfbfbf" }}>—</span>;
          const { estado, motivo, esperado, actual, diferencia, anios, factor } = revision;
          if (estado === "ok") {
            return <Tag color={SBC_TAG_COLOR.ok}>Correcto</Tag>;
          }
          if (estado === "noEvaluable") {
            return (
              <Tooltip title={MOTIVO_SBC_TEXTO[motivo] || ""}>
                <Tag color={SBC_TAG_COLOR.noEvaluable}>No evaluable</Tag>
              </Tooltip>
            );
          }
          return (
            <Tooltip
              title={
                <div style={{ lineHeight: 1.5 }}>
                  <div>Capturado: {dineroDisabledMask(actual || 0)}</div>
                  <div>Calculado: {dineroDisabledMask(esperado)}</div>
                  <div>Diferencia: {diferencia > 0 ? "+" : ""}{dineroDisabledMask(diferencia)}</div>
                  <div style={{ marginTop: 4, opacity: 0.85 }}>
                    Antigüedad {anios} año(s) · factor {factor}
                  </div>
                </div>
              }
            >
              <Tag color={SBC_TAG_COLOR[estado]}>{nombreEstadoSbc(estado)}</Tag>
            </Tooltip>
          );
        },
      },
      // Recibos de nómina que ya se mandaron a timbrar y no salieron (`recibosSinTimbrar`, lo
      // calcula el backend). Es la explicación del renglón rojo: qué nómina y por qué.
      {
        title: "Timbrado",
        key: "timbrado",
        align: "center",
        width: 120,
        filters: [
          { text: "Con recibos sin timbrar", value: "sinTimbrar" },
          { text: "Al corriente", value: "alCorriente" },
        ],
        onFilter: (value, record) => (value === "sinTimbrar") === tieneRecibosSinTimbrar(record),
        sorter: (a, b) => numRecibosSinTimbrar(b) - numRecibosSinTimbrar(a),
        render: (_, record) => {
          const recibos = record.recibosSinTimbrar || [];
          if (!recibos.length) return <span style={{ color: "#bfbfbf" }}>—</span>;
          const resto = recibos.length - MAX_RECIBOS_TOOLTIP;
          return (
            <Tooltip
              overlayStyle={{ maxWidth: 420 }}
              title={
                <div style={{ lineHeight: 1.4 }}>
                  {recibos.slice(0, MAX_RECIBOS_TOOLTIP).map((r, i) => (
                    <div key={i} style={{ marginBottom: 6 }}>
                      <div style={{ fontWeight: 600 }}>{encabezadoRecibo(r)}</div>
                      <div style={{ opacity: 0.85 }}>{motivoRecibo(r)}</div>
                    </div>
                  ))}
                  {resto > 0 && <div style={{ opacity: 0.85 }}>y {resto} más</div>}
                </div>
              }
            >
              <Tag color="error" icon={<WarningOutlined />} style={{ margin: 0 }}>
                {recibos.length} sin timbrar
              </Tag>
            </Tooltip>
          );
        },
      }] : []),
      {
        title: "Departamento",
        dataIndex: "departamento",
        key: "departamento",
        sorter: (a, b) => (a.departamento || "").localeCompare(b.departamento || ""),
        buscar: "departamento",
      },
      {
        title: "Puesto",
        dataIndex: "puesto",
        key: "puesto",
        sorter: (a, b) => (a.puesto || "").localeCompare(b.puesto || ""),
        buscar: "puesto",
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        align: "center",
        // Cabe un botón más desde que existe "Unificar con…".
        width: isMobile ? "16%" : "12%",
        onHeaderCell: () => ({
          style: { textAlign: 'center', padding: '4px' }
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: 'center', padding: '4px' }
        }),
        render: (value, index) => {
          let buttons = [];

          if (this.props.nomina) {
            buttons.push(
              <Tooltip title="Validar datos para timbrar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  key={`validar-${index}`}
                  type="default"
                  size="small"
                  azul
                  icon={<SafetyCertificateOutlined />}
                  onClick={() => this.validarEmpleado(value._id)}
                />
              </Tooltip>
            );
          }

          // Ficha incompleta: lo único que se hace con ella es terminar su alta por pasos (ahí se
          // editan también sus datos). Ni habilitar, ni finiquito, ni unificar.
          if (value.estado === 3) {
            if (this.props.permisoAgregarEmpleado) {
              buttons.push(
                <Tooltip title="Continuar alta por pasos" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <ButtonItem
                    key={`continuarAlta-${index}`}
                    type="default"
                    size="small"
                    naranja
                    icon={<UserAddOutlined />}
                    onClick={() => this.altaEmpleadoPorPasos(value._id)}
                  />
                </Tooltip>
              );
            }
            return <Space size="small">{buttons}</Space>;
          }

          if (this.props.permisoEditarEmpleado) {
            buttons.push(
              <Tooltip title="Editar Empleado" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  key={`editar-${index}`}
                  type="default"
                  size="small"
                  cyan
                  icon={<EditOutlined />}
                  onClick={() => this.editarEmpleado(value._id, value.estado)}
                />
              </Tooltip>
            );
          }

          if (this.props.permisoDeshabilitarEmpleado) {
            if (value.estado === 1) {
              buttons.push(
                <Tooltip title="Deshabilitar Empleado" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <Popconfirm
                    title="Seguro que quieres deshabilitar este empleado"
                    onConfirm={() => this.deshabilitarEmpleado(value._id)}
                    okText="Si"
                    cancelText="No"
                  >
                    <ButtonItem
                      key={`deshabilitar-${index}`}
                      type="default"
                      size="small"
                      lima
                      icon={<CheckCircleOutlined />}
                    />
                  </Popconfirm>
                </Tooltip>
              );
            } else if (value.unificado) {
              // Un duplicado unificado no se habilita ni se reingresa (habilitar lo rechaza el
              // backend): lo del reloj ya está en el otro registro. La columna "Baja" dice con quién.
            } else if (value.fechaBaja) {
              // Con una baja laboral "Habilitar" siempre se rechaza: la salida es el reingreso,
              // que reactiva el mismo registro y deja la baja y el finiquito como historia.
              buttons.push(
                <Tooltip title="Reingresar Empleado" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <ButtonItem
                    key={`reingresar-${index}`}
                    type="default"
                    size="small"
                    verde
                    icon={<UserAddOutlined />}
                    onClick={() => this.setState({ reingreso: { visible: true, empleadoId: value._id } })}
                  />
                </Tooltip>
              );
            } else {
              buttons.push(
                <Tooltip title="Habilitar Empleado" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <Popconfirm
                    title="Seguro que quieres habilitar este empleado"
                    onConfirm={() => this.habilitarEmpleado(value._id)}
                    okText="Si"
                    cancelText="No"
                  >
                    <ButtonItem
                      key={`habilitar-${index}`}
                      type="default"
                      size="small"
                      rojo
                      icon={<StopOutlined />}
                    />
                  </Popconfirm>
                </Tooltip>
              );
            }

            // El botón se muestra también con estado 2: aplicar un finiquito deja al empleado
            // deshabilitado, y sin esto no habría forma de volver a entrar a consultarlo, sacar
            // la carta o deshacerlo. Antes la condición era sólo `estado === 1`, así que un
            // proceso a medias quedaba irrecuperable.
            if (value.estado === 1 || value.estado === 2) {
              buttons.push(
                <Tooltip
                  title={
                    value.finiquitoId
                      ? "Ver finiquito"
                      : value.fechaBaja
                        ? "Continuar finiquito"
                        : "Dar de baja / finiquito"
                  }
                  placement="top"
                  overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                >
                  <ButtonItem
                    key={`finiquito-${index}`}
                    type="default"
                    size="small"
                    naranja
                    icon={<UserDeleteOutlined />}
                    onClick={() => this.props.history.push(`/panel/finiquito/${value._id}`, { id: value._id })}
                  />
                </Tooltip>
              );
            }

            // Unificar a mano, para los duplicados que la pantalla de detectados no propone. Con
            // reloj el renglón entra como el duplicado (el que se deshabilita); sin reloj, como el
            // que se queda.
            if (!value.unificado) {
              buttons.push(
                <Tooltip title="Unificar con…" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <ButtonItem
                    key={`unificar-${index}`}
                    type="default"
                    size="small"
                    turquesa
                    icon={<MergeCellsOutlined />}
                    onClick={() => this.setState({
                      unificar: {
                        visible: true,
                        duplicadoId: value.tieneReloj ? value._id : null,
                        conservarId: value.tieneReloj ? null : value._id,
                      },
                    })}
                  />
                </Tooltip>
              );
            }
          }

          return <Space size="small">{buttons}</Space>;
        },
      },
    ];

    return (
      <>
        <PageHeader
          title="Empleados"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              {window.innerWidth > 1000 &&
                <SegmentedItem
                  options={[
                    { label: 'Activo', value: 1 },
                    { label: 'Deshabilitado', value: 2 },
                    // Fichas del alta por pasos que todavía no se completan (estado 3).
                    ...(this.props.altaEmpleadoPorPasos ? [{ label: 'Fichas incompletas', value: 4 }] : []),
                    { label: 'Todos', value: 3 },
                  ]}
                  onChange={(value) => {
                    this.consultarEmpleados(value)
                    this.setState({ valor: value })
                  }}
                  value={this.state.valor}
                />
              }
              <HeaderActions>
                {this.props.permisoAgregarEmpleado && (
                  <ButtonItem
                    type="primary"
                    azul
                    onClick={() => this.props.history.push('/panel/aumentoSueldo')}
                    className="botonAgregar"
                  >
                    Aumento de Sueldo
                  </ButtonItem>
                )}
                {this.props.permisoAgregarEmpleado &&
                  <ButtonItem
                    type="primary"
                    cafe
                    key="importarEmpleados"
                    onClick={this.importarEmpleados.bind(this)}
                    className="botonAgregar"
                  >
                    Importar Empleados
                  </ButtonItem>}
                {/* Mismo permiso que la Edición Masiva: su "Descargar Excel" ya expone estos datos
                    (salarios, CLABE, NSS). El archivo sale con la plantilla de Importar Empleados. */}
                {this.props.permisoEdicionMasivaEmpleados &&
                  <ButtonItem
                    type="default"
                    key="exportarEmpleados"
                    icon={<DownloadOutlined />}
                    verde
                    onClick={() => this.setState({ exportarVisible: true })}
                  >
                    Exportar Empleados
                  </ButtonItem>}
                {this.props.permisoAgregarEmpleado &&
                  <ButtonItem
                    type="primary"
                    morado
                    key="importarEmpleadosExterno"
                    onClick={() => this.props.history.push('/panel/importarEmpleadosExterno')}
                    className="botonAgregar"
                  >
                    Importar Desde Software Externo
                  </ButtonItem>}
                {this.props.permisoEdicionMasivaEmpleados &&
                  <ButtonItem
                    type="default"
                    key="edicionMasivaEmpleados"
                    icon={<TableOutlined />}
                    verde
                    onClick={() => this.props.history.push('/panel/edicionMasivaEmpleados')}
                  >
                    Edición Masiva
                  </ButtonItem>}
                {this.props.permisoEdicionMasivaEmpleados &&
                  <ButtonItem
                    type="default"
                    key="edicionMasivaEmpleadosExterno"
                    icon={<TableOutlined />}
                    lila
                    onClick={() => this.props.history.push('/panel/edicionMasivaEmpleadosExterno')}
                  >
                    Edición Masiva Externa
                  </ButtonItem>}
                {this.props.nomina &&
                  <ButtonItem
                    type="default"
                    key="validarTimbrado"
                    icon={<SafetyCertificateOutlined />}
                    azul
                    onClick={() => this.validarTodos(false)}
                  >
                    Validar Timbrado
                  </ButtonItem>}
                {/* El banner sólo aparece si hay algo desfasado; este botón deja abrir la
                    revisión siempre, aunque esté todo al día o ya se haya cerrado el modal. */}
                {this.props.nomina &&
                  <ButtonItem
                    type="default"
                    key="revisionSbc"
                    icon={<WarningOutlined />}
                    naranja
                    onClick={() => this.setState({ sbcVisible: true })}
                  >
                    Revisar SBC
                  </ButtonItem>}
                {/* Mismo permiso que deshabilitar: unificar deja al duplicado deshabilitado. */}
                {this.props.permisoDeshabilitarEmpleado &&
                  <ButtonItem
                    type="default"
                    key="unificarDuplicados"
                    icon={<MergeCellsOutlined />}
                    turquesa
                    onClick={() => this.setState({ unificarDuplicadosVisible: true })}
                  >
                    Unificar Duplicados
                  </ButtonItem>}
                {/* Traspasar es dar de alta en otra empresa: mismo permiso que agregar. */}
                {this.props.permisoAgregarEmpleado &&
                  <ButtonItem
                    type="default"
                    key="traspasoEmpleados"
                    icon={<ExportOutlined />}
                    morado
                    onClick={() => this.setState({ traspasoVisible: true })}
                  >
                    Traspasar a otra empresa
                  </ButtonItem>}
                {/* TEMPORAL: comentar antes de producción (copia de biometría a otra empresa, sin permiso). */}
                <ButtonItem
                  type="default"
                  key="copiarBiometria"
                  icon={<ExportOutlined />}
                  morado
                  onClick={() => this.setState({ copiarBiometriaVisible: true })}
                >
                  Copiar biometría a otra empresa
                </ButtonItem>
              </HeaderActions>
              {/* Convive con "Agregar Empleado": el complemento agrega la opción, no la impone. */}
              {this.props.permisoAgregarEmpleado && this.props.nomina && this.props.altaEmpleadoPorPasos &&
                <ButtonItem
                  type="primary"
                  key="altaEmpleadoPorPasos"
                  naranja
                  icon={<UserAddOutlined />}
                  onClick={() => this.altaEmpleadoPorPasos()}
                  className="botonAgregar"
                >
                  Alta por pasos
                </ButtonItem>}
              {this.props.permisoAgregarEmpleado &&
                <ButtonItem
                  type="primary"
                  key="agregarEmpleado"
                  olivo
                  onClick={this.agregarEmpleado.bind(this)}
                  className="botonAgregar"
                >
                  Agregar Empleado
                </ButtonItem>}
            </div>
          }
        />
        {empleadosSinTimbrar > 0 && (
          <div
            style={{
              backgroundColor: "white",
              border: "1px solid rgb(235, 237, 240)",
              borderLeft: `4px solid ${COLOR_SIN_TIMBRAR}`,
              padding: "8px 12px",
              marginBottom: 10,
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            <WarningOutlined style={{ color: COLOR_SIN_TIMBRAR }} />
            <span>
              <strong>{empleadosSinTimbrar}</strong>
              {empleadosSinTimbrar === 1
                ? " empleado tiene recibos de nómina sin timbrar"
                : " empleados tienen recibos de nómina sin timbrar"}
              {" "}(error al timbrar o pendientes en una nómina ya cerrada). Usa el filtro de la columna Timbrado para verlos.
            </span>
          </div>
        )}
        {resumenSbc.desfasados > 0 && (
          <div
            onClick={() => this.setState({ sbcVisible: true })}
            style={{
              backgroundColor: "white",
              borderLeft: `4px solid ${SBC_COLOR.menor}`,
              border: "1px solid rgb(235, 237, 240)",
              borderLeftWidth: 4,
              padding: "8px 12px",
              marginBottom: 10,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            <WarningOutlined style={{ color: SBC_COLOR.menor }} />
            <span>
              <strong>{resumenSbc.desfasados}</strong>
              {resumenSbc.desfasados === 1
                ? " empleado tiene el Salario Base de Cotización desfasado"
                : " empleados tienen el Salario Base de Cotización desfasado"}
              {resumenSbc.menor > 0 && resumenSbc.mayor > 0
                ? ` (${resumenSbc.menor} por debajo, ${resumenSbc.mayor} por encima del calculado)`
                : ""}
              .
            </span>
            <span style={{ color: "#00BFD6", textDecoration: "underline" }}>Ver detalle</span>
          </div>
        )}
        <TableItem
          loading={this.state.loading}
          size='small'
          dataSource={this.state.todasEmpleados}
          columns={columns}
          estadosLeyenda={[
            { color: COLOR_RELOJ, label: "Con reloj checador", key: "conReloj" },
            ...(this.props.nomina ? [
              { color: COLOR_SIN_TIMBRAR, label: "Recibo de nómina sin timbrar", key: "sinTimbrar" },
              { color: SBC_COLOR.menor, label: "SBC menor al calculado", key: "sbcMenor" },
              { color: SBC_COLOR.mayor, label: "SBC mayor al calculado", key: "sbcMayor" },
            ] : []),
          ]}
          // Con `rowClassName` propio se apaga el zebra por defecto de TableItem, así que hay que
          // devolverlo a mano para los renglones que no pinta nadie.
          // Orden: recibo sin timbrar (un CFDI que falta ante el SAT) le gana a la revisión de SBC
          // (alerta ante el IMSS), y ésta al color de reloj; la etiqueta de SBC y el ícono de reloj
          // siguen a la vista en su columna aunque el renglón salga de otro color.
          // En la vista "Deshabilitado", un renglón con color de reloj es un deshabilitado al que
          // le siguen llegando checadas: candidato a unificar.
          rowClassName={(record, index) => {
            if (this.props.nomina && tieneRecibosSinTimbrar(record)) return CLASE_FILA_SIN_TIMBRAR;
            const clase = this.props.nomina ? claseFilaSbc(record.sbcRevision?.estado) : null;
            if (clase) return clase;
            if (record.relojes?.length) return "empleado-con-reloj";
            return index % 2 === 0 ? "zebra-gris" : "default";
          }}
          onRow={(record) => ({
            onDoubleClick: () => this.editarEmpleado(record._id, record.estado),
          })}
        />
        <ModalValidacionTimbrado
          visible={this.state.validacion.visible}
          loading={this.state.validacion.loading}
          resultados={this.state.validacion.resultados}
          onCancel={this.cerrarValidacion.bind(this)}
          titulo={this.state.validacion.masivo ? "Validación de timbrado de los empleados" : "Validación de datos para timbrar"}
          mensajeVacio="No hay empleados activos que validar."
          onDescargarXml={(item) => this.descargarXmlEmpleado(item)}
          footerExtra={
            this.state.validacion.masivo && !this.state.validacion.loading ? (
              <ButtonItem
                type="default"
                azul
                icon={<SafetyCertificateOutlined />}
                onClick={() => this.validarTodos(true)}
              >
                Consultar el SAT
              </ButtonItem>
            ) : null
          }
        />
        <ModalSbcDesactualizado
          visible={this.state.sbcVisible}
          loading={this.state.sbcCorrigiendo}
          empleados={this.state.todasEmpleados}
          onCancel={() => this.setState({ sbcVisible: false })}
          // Corregir escribe el SBC del empleado, así que va tras el mismo permiso que editarlo.
          onCorregir={this.props.permisoEditarEmpleado ? this.corregirSbc.bind(this) : undefined}
        />
        <ModalExportarEmpleados
          visible={this.state.exportarVisible}
          onCancel={() => this.setState({ exportarVisible: false })}
        />
        <ModalTraspasoEmpleados
          visible={this.state.traspasoVisible}
          onCerrar={(huboCambios) => {
            this.setState({ traspasoVisible: false });
            if (huboCambios) this.consultarEmpleados(this.state.valor);
          }}
        />
        {/* TEMPORAL: comentar antes de producción junto con su botón. */}
        <ModalCopiarBiometria
          visible={this.state.copiarBiometriaVisible}
          onCerrar={() => this.setState({ copiarBiometriaVisible: false })}
        />
        <ModalReingreso
          visible={this.state.reingreso.visible}
          empleadoId={this.state.reingreso.empleadoId}
          onCerrar={(reingresado) => {
            this.setState({ reingreso: { visible: false, empleadoId: null } });
            if (reingresado) this.consultarEmpleados(this.state.valor);
          }}
        />
        <ModalUnificarDuplicados
          visible={this.state.unificarDuplicadosVisible}
          onCerrar={(huboCambios) => {
            this.setState({ unificarDuplicadosVisible: false });
            if (huboCambios) this.consultarEmpleados(this.state.valor);
          }}
        />
        <ModalUnificarEmpleado
          visible={this.state.unificar.visible}
          duplicadoId={this.state.unificar.duplicadoId}
          conservarId={this.state.unificar.conservarId}
          onCerrar={(unificado) => {
            this.setState({ unificar: { visible: false, duplicadoId: null, conservarId: null } });
            if (unificado) this.consultarEmpleados(this.state.valor);
          }}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    // La validación de timbrado sólo tiene sentido con el módulo de nómina
    // prendido: es lo que decide si a este empleado se le va a emitir un CFDI.
    nomina: state.empresa.nomina,
    altaEmpleadoPorPasos: state.empresa.altaEmpleadoPorPasos,
    permisoAgregarEmpleado:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "675096a4798d4e0043687255"
      )?.activado,
    permisoEditarEmpleado:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "675096cb798d4e0043687256"
      )?.activado,
    permisoDeshabilitarEmpleado:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "675096f0798d4e0043687257"
      )?.activado,
    permisoEdicionMasivaEmpleados:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a56dcde1d3d236b279ce601"
      )?.activado,
  };
};

export default connect(mapStateToProps)(Empleados);
